module.exports = __webpack_public_path__ + "img/bg-section-04-mobile.b07e5a00.svg";